import { useAuthStore } from "core/stores/authStore";

const authGuard = () => {
  const isAuthenticated = useAuthStore.getState().checkSession();
  // console.log("🔐 AuthGuard: Checking authentication", { isAuthenticated });
  return isAuthenticated;
};

export default authGuard;
